import { STORE_KEY_LANG } from '@/constants';
const LANG = window.localStorage.getItem(STORE_KEY_LANG) || navigator.language.substr(0,2) || 'en';

export function printDate(timestamp) {
  if (!timestamp) return;
  return new Date(timestamp).toLocaleDateString( LANG );
}
export function printDatetime(timestamp) {
  if (!timestamp) return;
  const d = new Date(timestamp);
  return d.toLocaleString( LANG );
}

export function ISODate(timestamp) {//TODO: replaced by toISOString()
  if (!timestamp)
    return;
  return new Date(timestamp).toISOString().substr(0, 10);
}
export function ISODateTime(timestamp) {//TODO: replaced by toISODateTimeString() - TODO
  if (!timestamp)
    return;
  return new Date(timestamp).toISOString().substr(0, 19).replace(/T/, ' ');
}

export function textColor(colorStr) {
  if(!colorStr)
    return;
  const names = colorStr.split(' ');
  return (
    (names[0] + '--text') +
    (names[1] ? ' text--' + names[1] : '')
  );
}

export function getColorRatio(val, max) {
  if (!max)
    max = 100;
  const ratio = val / max * 100;
  return 'hsla(' + ratio + ', 90%, 45%, .9)';
}

export function openInNew(link) {
  //console.log(__webpack_public_path__, process.env.NODE_ENV); return;
  link = link.replace(/^\/?/, '');
  let win = window.open(__webpack_public_path__ + '#/' + link, '_blank');
  win.focus();
}

/*-------------------- utils.js from SalesSteps from ClientCabinet (and edited) --------------------*/

export function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function validatePhone(phone) {
  return !!/^\+?\d[\d\s]*$/g.exec(phone);
}

//export function showErrors(res) {
//  const body = res.body ? res.body : {};
//  let msg = '';
//  if (res.message)
//    msg = res.message;
//  else if (body.message)
//    msg = body.message;
//  else if (body.errors || res.errors) {
//    const errors = body.errors ? body.errors : res.errors;
//    msg = errors.map(err => err.message).join(', ');
//  }
//  return msg;
//}

export function getErrors(err) {
  if (!err)
    return '';
  let msg = '';
  if (err.body && err.body.errors) {
    err.body.errors.forEach(element => msg += element.message+' ,');
    msg = msg.substring(0, msg.length - 1);
  }
  return msg;
}

export function downloadFile(response) {
  let filename = "";
  let mime = response.headers.get("content-type") || "application/octet-stream";
  let disp = response.headers.get("content-disposition");
  if (disp && disp.indexOf("attachment") !== -1) {
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      let matches = filenameRegex.exec(disp);
      if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
  }

  let blob = typeof File === "function" && !window.navigator.msSaveBlob // (2019-10-14) Gorgi: better use Blob only due to lack of (or partial) support of File by most browsers
      ? new File([response.body], filename, { type: mime })
      : new Blob([response.body], { type: mime });

  if (typeof window.navigator.msSaveBlob !== "undefined") {
    // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
    window.navigator.msSaveBlob(blob, filename);
  } else {

    let URL = window.URL || window.webkitURL;
    let downloadUrl = URL.createObjectURL(blob);
    // use HTML5 a[download] attribute to specify filename
    let a = document.createElement("a");
    // safari doesn't support this yet
    if (typeof a.download === "undefined") {

      window.location = downloadUrl;
    } else {

      a.style.display = 'none';
      a.href = downloadUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    setTimeout(() => URL.revokeObjectURL(downloadUrl), 100); // cleanup
  }
}

/*-------------------- utils.js from CEZ-Electro (LWC) --------------------*/

/**
 * Process errors deep, accumulating all values of message fields [dive]
 * @param {Object} obj Every next iteration item to check for
 * @param {String} msg Final message string
 */
export function extractMsgs(obj, msg) {
	if (!msg)
		msg = '';
	if (!!obj && typeof obj === 'object') {
		Object.keys(obj).forEach(key => {
			if (key === 'message' && !!obj[key]) {
				let msgObj = obj[key];
				if (typeof msgObj != 'object') {
					try {
						msgObj = JSON.parse(msgObj);
					}
					catch(e) {
					}
				}
				if (typeof msgObj === 'object') {
					msg = extractMsgs(msgObj, msg);
				}
				else {
					msg += msgObj + '\n';
				}
			} else {
				msg = extractMsgs(obj[key], msg);
			}
		});
	}
	return msg;
}

export function toISOString(date) {
	if (!date)
		return;
  date = new Date(date);

  return `${       date.getFullYear()
        }-${ ('0'+(date.getMonth()+1)).slice(-2)
        }-${ ('0'+(date.getDate())   ).slice(-2)
        }`

  //return    date.getFullYear()               + '-' +
  //  ('0' + (date.getMonth() + 1) ).slice(-2) + '-' +
  //  ('0' +  date.getDate()       ).slice(-2);
}
